export const localStorage = {
  set: (key: string, value: unknown): void => {
    const json = JSON.stringify(value);
    window.localStorage.setItem(key, json);
  },

  get: (key: string): string | null => {
    const json = window.localStorage.getItem(key);

    if (!json) {
      return null;
    }

    try {
      return JSON.parse(json);
    } catch (e) {
      window.localStorage.removeItem(key);
      return null;
    }
  },

  delete: (key: string): void => window.localStorage.removeItem(key),
};
